import { render, staticRenderFns } from "./yaowen.vue?vue&type=template&id=aee45a5e&scoped=true"
import script from "./yaowen.vue?vue&type=script&lang=js"
export * from "./yaowen.vue?vue&type=script&lang=js"
import style0 from "./yaowen.vue?vue&type=style&index=0&id=aee45a5e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aee45a5e",
  null
  
)

export default component.exports